var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "er-actions-cell-wrapper",
    },
    [
      _c(
        "pui-button",
        {
          attrs: {
            icon: "visible",
            state: "secondary",
            small: true,
          },
          on: {
            click: _vm.sendToEngineRunSummary,
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("engineRun.overview.engineRunTable.actions.viewMore")
              ) +
              " "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }